import { useEffect, useState } from "react";

type AsyncModuleLoader<T> = () => Promise<T>;

const useAsyncModule = <T>(
  moduleLoader: AsyncModuleLoader<T>
): [T | null, boolean] => {
  const [asyncModule, setAsyncModule] = useState<T | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let isMounted = true;

    const getAsyncModule = async () => {
      try {
        const result = await moduleLoader();

        if (isMounted) {
          setAsyncModule(result);
        }
      } catch (error) {
        console.error("Error loading async module:", error);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    getAsyncModule();

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, []);

  return [asyncModule, loading];
};

export default useAsyncModule;
